import { useTranslation } from 'react-i18next';
import { DropdownStyled } from 'src/components';
import { type OrgFilterBy } from 'src/types';
import { FilterItems } from '.';

type Props = {
  filterBy: OrgFilterBy;
  setFilterBy: (filterBy: OrgFilterBy) => void;
};

export const FilterByDropdown = ({ filterBy, setFilterBy }: Props) => {
  const { t } = useTranslation();

  return (
    <DropdownStyled
      className='w-[160px] min-w-[160px] max-w-[160px]'
      buttonContent={
        <span className='truncate whitespace-nowrap font-secondary text-base font-semibold leading-6 text-primary-dark'>
          {t(`org_settings.filter.${filterBy}`)}
        </span>
      }
      darkStyle={false}
    >
      {(closeDropdown) => (
        <div className='z-20 flex min-w-[200px] flex-col items-start justify-center rounded-lg bg-cloudGray font-secondary xs:min-w-[240px]'>
          <div className='flex w-full flex-col items-start gap-2 py-4 pl-6 pr-4 font-semibold'>
            <FilterItems
              handleClick={closeDropdown}
              filterBy={filterBy}
              setFilterBy={setFilterBy}
            />
          </div>
        </div>
      )}
    </DropdownStyled>
  );
};
